export default __webpack_public_path__ + "static/media/MadScientists_Keyvisual_1.c9dcd579.jpg";